import attribute from 'dom-helpers/attribute';
import ownDoc from 'dom-helpers/ownerDocument';
import qsa from 'dom-helpers/querySelectorAll';
import React from 'react';
import { useSelector } from 'react-redux';
import { useTrans } from '../core/hooks';
import {
  selectActiveParentCity,
  selectActiveProductType,
} from '../core/redux/features/products/reducers/productTypes';
import { AppState } from '../core/redux/reducers';

function useLanguage() {
  const activeLocale = useSelector((state: AppState) => state.local);
  const activeParentArea = useSelector(selectActiveParentCity);
  const trans = useTrans();
  const activeProductType = useSelector(selectActiveProductType);
  const getCurrentPageLink = (locale: string) => {
    return (
      (activeParentArea
        ? trans(
            `routes.${activeProductType.id}_by_city`,
            {
              city: activeParentArea?.slug,
            },
            '/' + locale,
            locale,
          )
        : '/' + locale) +
      '?switch=' +
      locale
    );
  };

  let pageLinks = React.useMemo(() => {
    return {
      en: getCurrentPageLink('en'),
      da: getCurrentPageLink('da'),
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeLocale]);

  return {
    trans,
    pageLinks,
    activeLocale,
    changeLocale: handleLanguageSwitch,
  };
}

function handleLanguageSwitch(local: string) {
  let metaLocals = qsa(
    ownDoc(),
    'link[rel="alternate"][hreflang="' + local + '"]',
  );

  try {
    let href = '/';
    if (metaLocals.length > 0) {
      href = attribute(metaLocals[0], 'href');
      new URL(href);
    } else {
      let isGuide =
        window.location.pathname.startsWith('/guide/') ||
        window.location.pathname.startsWith('/en/guide/');

      if (isGuide) {
        href = '/guide';
      }

      if (isGuide && local !== 'da') {
        href = '/' + local + href;
      }
    }

    window.location.href = href;
  } catch (_) {}
}

export default useLanguage;
